function adjustSchedulerTodayDateCustomTimezone() {

    const timeZoneDetails = getTimeZoneDetails();

    if (timeZoneDetails && timeZoneDetails.isDifferent) {

        //For p:scheduler we need to override function for retrieving current date and use it in extender attribute
        return function () {
            this.cfg.now = function () {
                return getCurrentDateForTimeZone(timeZoneDetails.timeZoneId);
            }
        }
    }
}

function adjustDatePickerTodayDateCustomTimezone() {

    const timeZoneDetails = getTimeZoneDetails();

    if (timeZoneDetails && timeZoneDetails.isDifferent) {

        const datePickers = $('.ui-calendar input');

        //Find and override behaviour of all p:calendar on the page
        if (datePickers.length > 0) {
            datePickers.each(function () {
                    overrideDatePickerTodayCalculation(this, timeZoneDetails);
                }
            )
        }
    }
}

function getTimeZoneDetails() {

    const timeZoneId = $('meta[name=timeZoneId]').attr('content');

    if (timeZoneId) {

        const currentDateForTimeZone = getCurrentDateForTimeZone(timeZoneId);
        const browserDate = new Date();

        return {
            'timeZoneId': timeZoneId,
            'browserDate': browserDate,
            'currentDateForTimeZone': currentDateForTimeZone,
            'isDifferent': currentDateForTimeZone.getDate() !== browserDate.getDate()
        }
    }
}

function overrideDatePickerTodayCalculation(datePickerInput, timeZoneDetails) {
    //Init
    $(datePickerInput).datepicker();

    const currentDateForTimeZone = timeZoneDetails.currentDateForTimeZone;
    //If we have end of the month, then it's possible that in specific timezone we have next month, so change it
    if (timeZoneDetails.browserDate.getMonth() !== currentDateForTimeZone.getMonth()) {
        $(datePickerInput).datepicker('option', 'defaultDate', currentDateForTimeZone);
    }

    //Modify calendar table
    $(datePickerInput).datepicker('option', 'beforeShow', function () {
        changeTodayDateForTimeZone(timeZoneDetails)
    });
}

function changeTodayDateForTimeZone(timeZoneDetails) {

    clearTimeout(changeTodayDateForTimeZone.timer);

    const dataPickerIdSelector = '#ui-datepicker-div';

    let datePickerCalendar = $(dataPickerIdSelector).find('.ui-datepicker-calendar');

    if (datePickerCalendar.is(':visible')) {

        //Bind events to the previous and next buttons
        addNavigationCallbacks(dataPickerIdSelector, '.ui-datepicker-prev', timeZoneDetails);
        addNavigationCallbacks(dataPickerIdSelector, '.ui-datepicker-next', timeZoneDetails);

        //Find element chosen by datepicker
        const datepickerTodayClassName = 'ui-datepicker-today';
        const todayDate = $(dataPickerIdSelector)
            .find("." + datepickerTodayClassName);

        const currentDateForTimeZone = timeZoneDetails.currentDateForTimeZone;

        //If today date highlighting is found then change today date
        if (todayDate.length > 0) {
            //Clear today date calculated by datepicker
            todayDate.removeClass(datepickerTodayClassName)

            //Change today based on own calculations
            $(todayDate)
                .siblings()
                .find('a')
                //Filter specific date for timezone
                .filter(function (index, element) {
                    return filterCalendarDate(index, element, currentDateForTimeZone)
                })
                .first()
                .parent()
                .addClass(datepickerTodayClassName)
        } else {

            //No today date found. For specific timezone it can be the next month, so find date and highlight it
            $(dataPickerIdSelector)
                .find('td')
                //Filter month like we have in the specific timezone date
                .filter(function (index, element) {
                    let calendarItemMonth = $(element).attr('data-month');
                    return calendarItemMonth && Number.parseInt(calendarItemMonth) === currentDateForTimeZone.getMonth();

                })
                .find('a')
                //Filter specific date for timezone
                .filter(function (index, element) {
                    return filterCalendarDate(index, element, currentDateForTimeZone)
                })
                .first()
                .parent()
                .addClass(datepickerTodayClassName)

        }
    } else {
        //If date picker is not yet visible, then wait and try again change today date
        changeTodayDateForTimeZone.timer = setTimeout(function () {
                changeTodayDateForTimeZone(timeZoneDetails);
            },
            10);
    }
}

function addNavigationCallbacks(dataPickerIdSelector, navigationButtonClass, timeZoneDetails) {
    $(dataPickerIdSelector)
        .find(navigationButtonClass)
        .on('click', function () {
            changeTodayDateForTimeZone(timeZoneDetails)
        });
}

function filterCalendarDate(index, element, currentDateForTimeZone) {
    const currentCalendarDate = Number.parseInt($(element).text());
    return currentCalendarDate === currentDateForTimeZone.getDate();
}

function getCurrentDateForTimeZone(timeZoneId) {

    function tryToGetCurrentDate(locale) {
        if (locale) {
            try {
                //For instance nl_NL locale combination with NZ timezone won't work or locale/timezone is incorrect
                return new Date(new Date().toLocaleString(locale, {timeZone: timeZoneId}));
            } catch (e) {
                //Just catch error then will be fallback
            }
        }
    }

    function isCurrentDateValid(currentDate) {
        return currentDate && !isNaN(currentDate.getTime());
    }

    /*
    Try to use default locale. Date object is very weak in parsing and supports not too much formats,
    so use the default one
    */
    const locale = 'en-US';

    let currentDateForTimezone = tryToGetCurrentDate(locale);

    if (isCurrentDateValid(currentDateForTimezone)) {
        return currentDateForTimezone;
    }

    //Return current date as fallback value based on browser's timezone
    return new Date();
}